import axios from 'axios'
import React, { useEffect, useState } from 'react';
import { axiosApi } from '../../utils/axiosApi';

const useGetAllCategories = (departmentName, subDepartment) => {

    const [allCategoriesOptions, setAllCategoriesOptions] = useState([])

    useEffect(() => {
        try {
            axiosApi(process.env.REACT_APP_BASE_URL + '/category/getAllCategory',
                {
                    departmentId: departmentName?.value ? departmentName?.value : "",
                    departmentName: departmentName?.label ? departmentName?.label : "",
                    subDepartmentId: subDepartment?.value ? subDepartment?.value : "",
                    subDepartmentName: subDepartment?.label ? subDepartment?.label : "",
                }
            )
                .then((res) => {
                    const filterOption = (res?.data?.data)?.length > 0 && (res?.data?.data)?.map((itm) => {
                        return ({ value: itm.categoryId, label: itm.categoryName })
                    })

                    if (filterOption?.length > 0) {
                        setAllCategoriesOptions(filterOption)
                    }
                })
                .catch((err) => {
                    console.log("Error", err)
                })
        } catch (error) {
            console.log("Error", error)
        }
    }, [departmentName, subDepartment])

    return { allCategoriesOptions }
}

export default useGetAllCategories